import { PageStepper } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { MESSAGES } from "./message-definitions";

export const ApplicationPageStepper = ({ currentStepIndex }: { currentStepIndex: number }) => {
  const intl = useIntl();
  return (
    <PageStepper
      steps={[
        intl.formatMessage(MESSAGES.stepCreateAccount),
        intl.formatMessage(MESSAGES.stepConnectPlatforms),
        intl.formatMessage(MESSAGES.stepFundingReview),
      ]}
      currentIndex={currentStepIndex}
    />
  );
};
